export function buildLocalizedPath(country: string, language: string, path = ''): string {
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const localeSegment = `${country}-${language}`;

    return normalizedPath ? `/${localeSegment}/${normalizedPath}` : `/${localeSegment}`;
}
